import { render } from "./InstallBanner.vue?vue&type=template&id=c855a57a&scoped=true"
import script from "./InstallBanner.vue?vue&type=script&lang=js"
export * from "./InstallBanner.vue?vue&type=script&lang=js"

import "./InstallBanner.vue?vue&type=style&index=0&id=c855a57a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aiden\\OneDrive - Qismat\\Development\\brydg-bdp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c855a57a"]])

export default __exports__